import React, { lazy, Suspense } from 'react';

const Alert = lazy(() => import('.'));

export const AsyncAlert = (props) => (
  <Suspense fallback={null}>
    <Alert {...props} />
  </Suspense>
);
